// extracted by mini-css-extract-plugin
module.exports = {"popupRow":"List_popupRow_1SYcC","pagination":"List_pagination_8Zbq4","paginationText":"List_paginationText_3iy5o","paginationButton":"List_paginationButton_Y4Hs6"};